<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <a href="#/profile" class="nav-link">
        <i class="nc-icon nc-single-02"></i> Profile
      </a>
    </li>
    <li class="nav-item">
      <a href="#/logout" class="nav-link">
        <i class="nc-icon nc-button-power"></i> Log out
      </a>
    </li>
    <!-- <drop-down>
      <template slot="title">
        <i class="nc-icon nc-bullet-list-67"></i>
      </template>
      <div class="divider"></div>
      <a class="dropdown-item" href="#/profile">
        <i class="nc-icon nc-settings-90"></i> Profile
      </a>
      <a href="#" class="dropdown-item text-danger">
        <i class="nc-icon nc-button-power"></i> Log out
      </a>
    </drop-down> -->
  </ul>
</template>
<script>
  import DropDown from '@/components/Dropdown.vue'

  export default {
    components: {
      DropDown
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/Extra/MobileMenu.vue